import { deprecated } from '@ally/metronome-icons';
import { useSearchAdornment } from '../context';
import { a11y } from '../../../strings';
export const useSearch = ({ onClick, ariaLabelShowResults = a11y.ariaLabelShowResults, }) => {
    const { clickCallback } = useSearchAdornment();
    const handleSearch = (e) => {
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
        // only trigger context callback for mouse events
        // we use a global key event listener for enter press events
        // enter presses will have a (0, 0) screen location
        if (e.screenX || e.screenY) {
            clickCallback === null || clickCallback === void 0 ? void 0 : clickCallback(e);
        }
    };
    return {
        variant: 'custom',
        position: 'right',
        item: {
            variant: 'interactive',
            'aria-label': ariaLabelShowResults,
            'data-testid': 'mui-search-adornment',
            onClick: handleSearch,
            icon: {
                icon: deprecated.muiSearch,
                fill: 'bluesuedeshoes',
            },
        },
    };
};
//# sourceMappingURL=useSearch.js.map